import { Link, useLocation } from "react-router-dom"
import { checkIsActive, toAbsoluteUrl } from "../../../helpers"

import { MediaImage } from "../../../framework/design/components"
import clsx from "clsx"
import { useAuth } from "../../../modules/auth"

export const SiteLogo = () => {
    const { pathname } = useLocation()
    const { siteId } = useAuth()
    const to = `/site(${siteId})/dashboard`;

    return (
        <>
            <Link
                className={clsx('menu-link py-3 bg-transparent', {
                    active: checkIsActive(pathname, to),
                })}
                to={to}>
                <div className="d-none d-lg-block"><LogoImage className="h-90px" /></div>
                <div className="d-lg-none"><LogoImage className="h-50px" /></div>
            </Link>
        </>
    )
}

const LogoImage = ({ className }: { className?: string }) => {
    const { site } = useAuth()

    if (!site) return <></>

    if (site.logo && site.logo !== '00000000-0000-0000-0000-000000000000')
        <MediaImage className={clsx(className)} mediaId={site?.logo} />

    return <img
        alt='Logo'
        className={clsx(className)}
        src={toAbsoluteUrl('/media/logos/JGULogo.png')}
    />
}